var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.048,
    height: 38.048,
    viewBox: "0 0 38.048 38.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3057",
    d: "M0-682.665H38.048v38.048H0Z",
    transform: "translate(0 682.665)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3051",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3053",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3055",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3061",
    transform: "translate(1.115 7.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3063",
    d: "M-327.344,0h-16.349a2.972,2.972,0,0,0-2.973,2.973v23.78a2.972,2.972,0,0,0,2.973,2.973h23.78a2.972,2.972,0,0,0,2.973-2.973V10.4",
    transform: "translate(346.666)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3065",
    transform: "translate(14.428 1.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3067",
    d: "M-373.909-78.6l-16.815,16.815-5.255,1.051,1.051-5.255L-378.113-82.8a1.486,1.486,0,0,1,2.1,0l2.1,2.1A1.486,1.486,0,0,1-373.909-78.6Z",
    transform: "translate(395.979 83.235)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3069",
    transform: "translate(30.192 3.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3071",
    d: "M0,0,4.2,4.2",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEditIcon);
export default __webpack_public_path__ + "static/media/message_Edit_Icon.31b003ded8cc2428e4c3507206f32927.svg";
export { ForwardRef as ReactComponent };